import React, { Component, Fragment } from 'react';
import Datetime from 'react-datetime';
import { _delete, get, patch, postWithHeaders, postWithHeadersResponse } from '../../../server/actions';
import moment from 'moment';
import $ from 'jquery'
import PropTypes from "prop-types";
import ToggleDisplay from 'react-toggle-display';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip';
import '../../../../src/assets/css/react-table.css'
import { BeatLoader } from 'react-spinners';
import 'react-tabs/style/react-tabs.css';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import NotificationSystem from 'react-notification-system';
import CustomSubmit from '../../Misc/customSubmit';
import _ from 'lodash';
import {
    _addNotification, _addNotificationError,
    getGradeNumberByText, getSchoolGrades, groupBy,
    convertTwoDecimalPoint, getModuleEnum, getAccessLevelByModule,
    getSalesTaxStatus, getSalesTaxRate, getSalesTaxAmount, getTotalAmountIncludeSalesTax, numberParce
} from '../../../server/util';
import { isShowOrderOption, isRegularLunchOrderType } from './orderOptionFilter';
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import { getTransactionOptions } from '../../Misc/MenuOptions/menuOptionsActions';
import { MealTypes, MenuOrderTypes, currency_symbol, date_format } from '../../../server/constants';
import Select from 'react-select';
var converter = require('number-to-words');
const CheckboxTable = checkboxHOC(ReactTable);
const today = moment();
const disableFutureDt = current => {
    return current.isBefore(today)
}
const modEnum = getModuleEnum();
let gradeList = [];
class addTransaction extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            filterData: [],
            startDate: moment().startOf('day'),
            columns: [],
            selection: [],
            selectAll: false,
            selectedRows: [],
            tabIndex: 0,
            lunchByTypeAndGrade: [],
            breakfastByType: [],
            purchsedStudents: [],
            response: false,
            _gradeName: 0,
            orderStatus: 'Ordered',
            seledtedDate: '',
            milkPriceObj: {},
            mealType: (getTransactionOptions()[0] || ''),
            isInstantPayment: false,
            freeMealForAll: false
        };
        this.renderInput = this.renderInput.bind(this);
    };
    componentWillMount = () => {
        this.initTransaction();
    }
    initTransaction = (clear = false) => {
        let schoolId = sessionStorage.getItem('SchoolId');
        let schoolYear = sessionStorage.getItem('schoolYearValue');
        let _isInstantPayment = getAccessLevelByModule(modEnum.IPFO);

        if (clear) {
            this.setState({
                data: [],
                filterData: [],
                selectAll: false,
                selection: [],
                selectedRows: [],
                lunchByTypeAndGrade: [],
                breakfastByType: [],
                purchsedStudents: [],
                response: false,
                milkPriceObj: {},
                isInstantPayment: _isInstantPayment
            }, () => {
                this.getPurchasedMenuStudents(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId);
                this.getByMealSchoolSchoolIdAndSchoolYear(schoolId, schoolYear)
                this.getMenuAvaialableByGrade(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId, schoolYear, this.state.orderStatus);
            })
        } else {
            this.setState({ isInstantPayment: _isInstantPayment });
            this.getPurchasedMenuStudents(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId);
            this.getByMealSchoolSchoolIdAndSchoolYear(schoolId, schoolYear)
            this.getMenuAvaialableByGrade(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId, schoolYear, this.state.orderStatus);
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    };
    getPurchasedMenuStudents = async (seledtedDate, schoolId) => {
        this.setState({ loading: true });
        await get(`/transactions/purchasedMenuStudents?selectedDate=${seledtedDate}&mealSchoolId=${schoolId}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const typeMeal = this.state.mealType;
            let _purchaseStudents = [];
            if (this.state.mealType === MealTypes.LUNCH) {
                _purchaseStudents = [...data[typeMeal] || [], ...data['LunchALaCarte'] || []];

            } else if (this.state.mealType === MealTypes.SNACK) {
                _purchaseStudents = [...data[typeMeal] || [], ...data['SnackALaCarte'] || []];

            } else if (this.state.mealType === MealTypes.BREAKFAST) {
                _purchaseStudents = [...data[typeMeal] || [], ...data['BreakfastALaCarte'] || []];
            } else if (this.state.mealType === MealTypes.DINNER) {
                _purchaseStudents = [...data[typeMeal] || [], ...data['DinnerALaCarte'] || []];
            }
            this.setState({ purchsedStudents: _purchaseStudents })
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Loading Report Failed", error)
        })
    }
    getByMealSchoolSchoolIdAndSchoolYear = async (schoolId, schoolYear) => {
        this.setState({ loading: true });

        await get(`/schoolYears/search/findByMealSchoolSchoolIdAndSchoolYear?mealSchoolId=${schoolId}&schoolYear=${schoolYear}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ milkPriceObj: data });
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Loading Report Failed", error)
        })

    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    getMenuAvaialableByGrade = async (seledtedDate, schoolId, schoolYear, status) => {
        const typeMeal = ((this.state.mealType === MealTypes.LUNCH) ? 'MEAL' : (this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER)
            ? this.state.mealType : ' ').toUpperCase();
        const typeMeal1 = ((this.state.mealType === MealTypes.LUNCH ||
            this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER) ? 'ENTREE' : this.state.mealType).toUpperCase();

        const extraMeal = ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER) ? 'EXTRA' : this.state.mealType).toUpperCase();
        this.setState({ loading: true, orderStatus: status });
        if (this.state.mealType === MealTypes.LUNCH ||
            this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER) {
            await get(`/transactions/menuAvailableByGradeV2?isVersion2=true&selectedDate=${seledtedDate}&menuType=${this.state.mealType}&mealSchoolId=${schoolId}&access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                this.setState({ lunchByTypeAndGrade: data.lunchByTypeAndGrade, breakfastByType: data.breakfastByType, loading: false });
                this.setState({ loading: true });
                get(`/transactions/studentsWithOrderedItemV2?isVersion2=true&schoolYear=${schoolYear}&menuType=${this.state.mealType}&selectedDate=${seledtedDate}&mealSchoolId=${schoolId}&access_token=`).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    this.setState({ response: data.response, freeMealForAll: data.freeMeal });
                    const { lunchByTypeAndGrade } = this.state;
                    let stData = [];
                    if (status === 'Ordered') {
                        stData = data['studentDetailsWithOrderedItems'].filter((item, index) => item.menuByType !== null);
                    } else {
                        const purchasedRecs = [...this.state.purchsedStudents];
                        //let list = data['studentDetailsWithOrderedItems'].filter((itx, index) => itx.menuByType !== null);
                        let list = data['studentDetailsWithOrderedItems'].filter(itm => {
                            return (itm.menuByType == null) || (itm.menuByType !== null && purchasedRecs.includes(itm.studentRecId));
                        }).map(item => {
                            item.menuByType = null;
                            return item;
                        });
                        let objList = [];
                        (Object.keys(lunchByTypeAndGrade) || []).map((itemVal, index) => {
                            let typeMeals = []
                            if (typeMeal && lunchByTypeAndGrade[itemVal].hasOwnProperty(typeMeal)) {
                                typeMeals = [...typeMeals, ...lunchByTypeAndGrade[itemVal][typeMeal]];
                            }
                            if (typeMeal1 && lunchByTypeAndGrade[itemVal].hasOwnProperty(typeMeal1)) {
                                typeMeals = [...typeMeals, ...lunchByTypeAndGrade[itemVal][typeMeal1]];
                            }
                            if (extraMeal && lunchByTypeAndGrade[itemVal].hasOwnProperty(extraMeal)) {
                                typeMeals = [...typeMeals, ...lunchByTypeAndGrade[itemVal][extraMeal]];
                            }
                            //if ((lunchByTypeAndGrade[itemVal][typeMeal] || lunchByTypeAndGrade[itemVal][typeMeal1] || []).length !== 0) {
                            if ((typeMeals || []).length !== 0) {
                                objList.push(itemVal);
                            }
                        })
                        stData = list.filter(item => objList.includes(item.gradeName));
                    }

                    let activeStData = stData;
                    return activeStData.map(item => {
                        let _id = item.studentId;
                        let trAmount = 0;
                        let trExAmount = 0;
                        let milkAmt = 0;
                        let itemSelected = 0;
                        if (item.menuByType !== null) {
                            itemSelected = 0;
                        } else {
                            (Object.keys(lunchByTypeAndGrade) || []).map((itemVal, index) => {
                                if (item.gradeName == itemVal) {
                                    let typeMeals = []
                                    if (typeMeal && lunchByTypeAndGrade[itemVal].hasOwnProperty(typeMeal)) {
                                        typeMeals = [...typeMeals, ...lunchByTypeAndGrade[itemVal][typeMeal]];
                                    }
                                    if (typeMeal1 && lunchByTypeAndGrade[itemVal].hasOwnProperty(typeMeal1)) {
                                        typeMeals = [...typeMeals, ...lunchByTypeAndGrade[itemVal][typeMeal1]];
                                    }
                                    (typeMeals || []).map((key, ind) => {
                                        if (ind === 0) {
                                            itemSelected = key.mealId;
                                        }
                                    })
                                }
                            })
                        }
                        if (data.response) { // check instant payment enable for school
                            if (item.menuByType !== null) {
                                trAmount = 0;
                            }

                        } else {
                            if (status === 'NotOrdered') {
                                trAmount = 0;
                                trExAmount = 0.00;

                            } else {
                                if (this.state.mealType === MealTypes.BREAKFAST) {
                                    if (item.isFreeMealEligible || item.isBeforeCare || (this.state.freeMealForAll === true)) {
                                        trAmount = 0;
                                    }
                                }
                                else if (item.isFreeMealEligible || (this.state.freeMealForAll === true)) {
                                    trAmount = 0;
                                    trExAmount = 0.00;
                                    ((item['menuByType'] || {})['EXTRA'] || []).map((item, key) => {
                                        trExAmount = trExAmount + ((item.mealPrice || 0) * (item.qty || 1));

                                    });
                                    trAmount = trAmount + trExAmount;
                                }
                                else if (item.isReducePriceEligible) {
                                    if (item.menuByType !== null) {
                                        trAmount = 0.00;
                                        trExAmount = 0.00;

                                        ((item['menuByType'] || {})[typeMeal] || (item['menuByType'] || {})['ENTREE'] || []).map((item, key) => {
                                            trAmount = trAmount + ((item.reducedPrice || 0) * (item.qty || 1))
                                        });
                                        ((item['menuByType'] || {})['EXTRA'] || []).map((item, key) => {
                                            trExAmount = trExAmount + ((item.mealPrice || 0) * (item.qty || 1))
                                        });
                                        trAmount = trAmount + trExAmount;
                                    } else {
                                        (Object.keys(lunchByTypeAndGrade) || []).map((itemVal, index) => {
                                            if (item.gradeName == itemVal) {
                                                (lunchByTypeAndGrade[itemVal][typeMeal] || []).map((key, ind) => {
                                                    if (ind === 0) {
                                                        trAmount = ((key.reducedPrice) * (item.qty || 1));
                                                    }
                                                })
                                            }
                                        })
                                    }
                                } else {
                                    if (item.menuByType !== null) {
                                        trAmount = 0.00;
                                        trExAmount = 0.00;
                                        ((item['menuByType'] || {})[typeMeal] || (item['menuByType'] || {})['ENTREE'] || []).map(itm => {
                                            trAmount = trAmount + ((itm.mealPrice || 0) * (itm.qty || 1))
                                        });
                                        ((item['menuByType'] || {})['EXTRA'] || []).map(itm => {
                                            trExAmount = trExAmount + ((itm.mealPrice || 0) * (itm.qty || 1))
                                        })
                                        trAmount = trAmount + trExAmount;
                                    } else {
                                        trAmount = 0;
                                        trExAmount = 0.00;
                                        (Object.keys(lunchByTypeAndGrade) || []).map((itemVal, index) => {
                                            if (item.gradeName == itemVal) {
                                                (lunchByTypeAndGrade[itemVal][typeMeal] || []).map((key, ind) => {
                                                    if (ind === 0) {
                                                        trAmount = (key.mealPrice * (key.qty || 1));

                                                    }
                                                })
                                            }
                                        })
                                    }

                                }
                            }
                        }
                        return {
                            _id,
                            trAmount,
                            mealtrAmt: trAmount,
                            extraTrAmt: trExAmount,
                            milktrAmt: milkAmt,
                            optMilk: 0,
                            optionExtraSelected: '',
                            ...item
                        };
                    });
                })
                    .then(data => {
                        const { purchsedStudents } = this.state;
                        let objList = data;
                        let result = [];
                        if (status === 'NotOrdered') {
                            result = objList;
                        } else {
                            result = objList.filter(el => (-1 == (purchsedStudents || []).indexOf(el.studentRecId)));
                        }
                        let columns = this.getColumns(result);
                        this.setState({ data: result, filterData: result, columns: columns, loading: false })
                    }).catch(error => {
                        this.setState({ loading: false });
                        console.log("Loading Report Failed", error)
                    })
            }).catch(error => {
                this.setState({ loading: false });
                console.log("Loading Report Failed", error)
            })
        }
    }

    hasMilkCardChange = (e, props) => {
        const { milkPriceObj, _gradeName, filterData } = this.state;
        let transAmount = 0;
        let statusVal = 0;
        let milktrAmt = 0;
        if (this.state.mealType === MealTypes.BREAKFAST) {
            if (e.target.checked) {
                statusVal = 1;
                if (props.isFreeMealEligible || props.isBeforeCare || (this.state.freeMealForAll === true)) {
                    transAmount = parseFloat(props.trAmount) + parseFloat(milkPriceObj.emrgMilkFreePrice);
                    milktrAmt = parseFloat(milkPriceObj.emrgMilkFreePrice);
                } else if (props.isReducePriceEligible) {
                    transAmount = parseFloat(props.trAmount) + parseFloat(milkPriceObj.emrgMilkRedPrice);
                    milktrAmt = parseFloat(milkPriceObj.emrgMilkRedPrice);
                } else {
                    transAmount = parseFloat(props.trAmount) + parseFloat(milkPriceObj.emrgMilkRegPrice);
                    milktrAmt = parseFloat(milkPriceObj.emrgMilkRegPrice);
                }
            } else {
                statusVal = 0;
                milktrAmt = 0;
                if (props.isFreeMealEligible || props.isBeforeCare || (this.state.freeMealForAll === true)) {
                    transAmount = parseFloat(props.trAmount) - parseFloat(milkPriceObj.emrgMilkFreePrice);
                } else if (props.isReducePriceEligible) {
                    transAmount = parseFloat(props.trAmount) - parseFloat(milkPriceObj.emrgMilkRedPrice);
                } else {
                    transAmount = parseFloat(props.trAmount) - parseFloat(milkPriceObj.emrgMilkRegPrice);
                }
            }
        }
        else {
            if (e.target.checked) {
                statusVal = 1;
                if (props.isFreeMealEligible || (this.state.freeMealForAll === true)) {
                    transAmount = parseFloat(props.trAmount) + parseFloat(milkPriceObj.emrgMilkFreePrice);
                    milktrAmt = parseFloat(milkPriceObj.emrgMilkFreePrice);
                } else if (props.isReducePriceEligible) {
                    transAmount = parseFloat(props.trAmount) + parseFloat(milkPriceObj.emrgMilkRedPrice);
                    milktrAmt = parseFloat(milkPriceObj.emrgMilkRedPrice);
                } else {
                    transAmount = parseFloat(props.trAmount) + parseFloat(milkPriceObj.emrgMilkRegPrice);
                    milktrAmt = parseFloat(milkPriceObj.emrgMilkRegPrice);
                }
            } else {
                statusVal = 0;
                milktrAmt = 0;
                if (props.isFreeMealEligible || (this.state.freeMealForAll === true)) {
                    transAmount = parseFloat(props.trAmount) - parseFloat(milkPriceObj.emrgMilkFreePrice);
                } else if (props.isReducePriceEligible) {
                    transAmount = parseFloat(props.trAmount) - parseFloat(milkPriceObj.emrgMilkRedPrice);
                } else {
                    transAmount = parseFloat(props.trAmount) - parseFloat(milkPriceObj.emrgMilkRegPrice);
                }
            }
        }
        let _data = filterData.map((item_val, index_val) => {
            if (props.studentRecId === item_val.studentRecId) {
                return { ...item_val, trAmount: transAmount, optMilk: statusVal, milktrAmt };
            } else {
                return item_val;
            }
        })
        let _slectedObj = this.state.selectedRows.map((item_value, index_value) => {
            if (props.studentRecId === item_value.studentRecId) {
                return { ...item_value, trAmount: transAmount, optMilk: statusVal, milktrAmt };
            } else {
                return item_value;
            }
        })
        let obj_data = _gradeName == 0 ? _data : _data.filter((itm, idx) => itm.gradeName === _gradeName)
        this.setState({ data: obj_data, filterData: _data, selectedRows: _slectedObj })
        this.forceUpdate();
    }

    menuItemChange = (e, props) => {
        const { freeMealForAll } = this.state;
        e.preventDefault();
        const typeMeal = ((this.state.mealType === MealTypes.LUNCH) ? 'MEAL' : (this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER)
            ? this.state.mealType : ' ').toUpperCase();
        const typeMeal1 = ((this.state.mealType === MealTypes.LUNCH ||
            this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER) ? 'ENTREE' : this.state.mealType).toUpperCase();
        const { lunchByTypeAndGrade, _gradeName, filterData } = this.state;
        let transAmount = 0;
        let mealId = 0;
        let typeMeals = []
        if (typeMeal && lunchByTypeAndGrade[props.gradeName].hasOwnProperty(typeMeal)) {
            typeMeals = [...typeMeals, ...lunchByTypeAndGrade[props.gradeName][typeMeal]];
        }
        if (typeMeal1 && lunchByTypeAndGrade[props.gradeName].hasOwnProperty(typeMeal1)) {
            typeMeals = [...typeMeals, ...lunchByTypeAndGrade[props.gradeName][typeMeal1]];
        }
        const rec = (typeMeals || []).find(itm => {
            return parseInt(itm.mealId) === parseInt(e.target.value)
        });
        if (rec) {
            mealId = rec.mealId;
            if (this.state.mealType === MealTypes.BREAKFAST) {
                const _purchsedStudents = this.state.purchsedStudents || [];
                let isPurchaseExists = false;
                if (this.state.orderStatus == 'NotOrdered') {
                    const sRec = _purchsedStudents.find(srId => {
                        return srId == props.studentRecId
                    });
                    if (sRec) {
                        isPurchaseExists = true;
                    }
                }
                if (isPurchaseExists) {
                    transAmount = rec.mealPrice;
                } else {
                    if (props.isFreeMealEligible || props.isBeforeCare || (this.state.freeMealForAll === true)) {
                        transAmount = 0;
                    } else if (props.isReducePriceEligible) {
                        transAmount = rec.reducedPrice;
                    } else {
                        transAmount = rec.mealPrice;
                    }
                }
            }
            else {
                const _purchsedStudents = this.state.purchsedStudents || [];
                let isPurchaseExists = false;
                if (this.state.orderStatus == 'NotOrdered') {
                    const sRec = _purchsedStudents.find(srId => {
                        return srId == props.studentRecId
                    });
                    if (sRec) {
                        isPurchaseExists = true;
                    }
                }
                if (isPurchaseExists) {
                    transAmount = rec.mealPrice;
                } else {
                    if (props.isFreeMealEligible || (this.state.freeMealForAll === true)) {
                        transAmount = 0;
                    } else if (props.isReducePriceEligible) {
                        transAmount = rec.reducedPrice;
                    } else {
                        transAmount = rec.mealPrice;
                    }
                }
            }
        }
        let _data = filterData.map((item_val, index_val) => {
            if (props.studentRecId === item_val.studentRecId) {
                return {
                    ...item_val,
                    trAmount: (transAmount + (item_val.extraTrAmt || 0.00)),
                    mealtrAmt: transAmount,
                    itemSelected: mealId === 0 ? undefined : mealId
                };
            } else {
                return item_val;
            }
        })
        let obj_data = _gradeName == 0 ? _data : _data.filter((itm, idx) => itm.gradeName === _gradeName)
        this.setState({ data: obj_data, filterData: _data }, () => {
            this.filterSchool();
        })
    }
    extraItemChange = (e, props) => {
        const typeMeal = ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER) ? 'EXTRA' : this.state.mealType).toUpperCase();
        const { lunchByTypeAndGrade, _gradeName, filterData } = this.state;
        let transAmount = 0;
        const _optionExtraSelected = [];
        (props.optionExtraSelected || '').split(',').map(itm => {
            const itmArray = itm.split(':');
            _optionExtraSelected.push({ itemId: itmArray[0], qty: itmArray[1] || '1' });
        })

        const recs = ((lunchByTypeAndGrade[props.gradeName] || {})[typeMeal] || []).filter(item => {
            const idx = (e || []).findIndex(sid => {
                return parseInt(item.mealId) === parseInt(sid.value)
            })
            if (idx !== -1) {
                return true;
            } else {
                return false
            }
        })

        if (recs.length > 0) {
            if ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER)
                //&& isRegularLunchOrderType()
            ) {
                recs.map(itm => {
                    const selectedItm = _optionExtraSelected.find(item => {
                        return itm.mealId == item.itemId;
                    })
                    transAmount = transAmount + (itm.mealPrice * (selectedItm ? parseInt(selectedItm.qty) : 1))
                })
            }
        }
        let _data = filterData.map((item_val, index_val) => {
            if (props.studentRecId === item_val.studentRecId) {
                return {
                    ...item_val,
                    trAmount: (transAmount + item_val.mealtrAmt),
                    extraTrAmt: transAmount,
                    optionExtraSelected: recs.map(item => {
                        const selectedItm = _optionExtraSelected.find(itm => {
                            return item.mealId == itm.itemId;
                        })
                        return item.mealId + (selectedItm ? ":" + parseInt(selectedItm.qty) : ":" + 1).toString()
                    }).join(',')
                };
            } else {
                return item_val;
            }
        })
        let obj_data = _gradeName == 0 ? _data : _data.filter((itm, idx) => itm.gradeName === _gradeName)
        this.setState({ data: obj_data, filterData: _data }, () => {
            this.filterSchool();
        })
    }
    getItemNames = (props) => {
        const { lunchByTypeAndGrade } = this.state;
        const typeMeal = ((this.state.mealType === MealTypes.LUNCH) ? 'MEAL' : (this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER)
            ? this.state.mealType : '').toUpperCase();
        const typeMeal1 = ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER) ? 'ENTREE' : this.state.mealType).toUpperCase();
        if (props.menuByType !== null) {
            let mealNamesArray = [];
            mealNamesArray = ((props['menuByType'] || {})[typeMeal] || (props['menuByType'] || {})[typeMeal1] || []).map(itm => {
                return itm.mealName
            })

            return (<Fragment><span data-tip data-for={'menu-' + props.studentRecId}>{(mealNamesArray || []).join(', ')}</span>
                <ReactTooltip id={'menu-' + props.studentRecId} aria-haspopup='true' place={'right'}
                    multiline={true} type="dark" effect="float" value={props.itemSelected}>
                    <div>{(mealNamesArray || []).map(itm => {
                        return (<Fragment><span>{itm}</span><br /></Fragment>)
                    })}</div></ReactTooltip></Fragment>)
        } else {

            return (

                <select className='form-control' value={props.itemSelected || ''}
                    onChange={(e) => this.menuItemChange(e, props)}>
                    <option value='' >Select</option>
                    {
                        (Object.keys(lunchByTypeAndGrade) || []).map((item, index) => {
                            if (props.gradeName == item) {
                                let typeMeals = []
                                if (typeMeal && lunchByTypeAndGrade[item].hasOwnProperty(typeMeal)) {
                                    typeMeals = [...typeMeals, ...lunchByTypeAndGrade[item][typeMeal]];
                                }
                                if (typeMeal1 && lunchByTypeAndGrade[item].hasOwnProperty(typeMeal1)) {
                                    typeMeals = [...typeMeals, ...lunchByTypeAndGrade[item][typeMeal1]];
                                }
                                return (
                                    typeMeals || []).map((key, ind) =>
                                        <option key={ind} value={key.mealId}>{key.mealName}</option>)
                            }
                        })
                    }
                </select>)
        }
    }
    handleChange = (e, props) => {
        this.extraItemChange(e, props)
    }
    getExtraItem = (props) => {
        const { lunchByTypeAndGrade } = this.state;
        const typeMeal = ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER) ? 'EXTRA' : this.state.mealType).toUpperCase();
        if (props.menuByType !== null) {
            let mealNamesArray = [];
            mealNamesArray = ((props['menuByType'] || {})[typeMeal] || []).map(itm => {
                return itm.mealName
            })
            return (<Fragment><span data-tip data-for={'menu-' + props.studentRecId}>{(mealNamesArray || []).join(', ')}</span>
                <ReactTooltip id={'menu-' + props.studentRecId} aria-haspopup='true' place={'right'}
                    multiline={true} type="dark" effect="float">
                    <div>{(mealNamesArray || []).map(itm => {
                        return (<Fragment><span>{itm}</span><br /></Fragment>)
                    })}</div></ReactTooltip></Fragment>)
        } else {
            const gradeItems = lunchByTypeAndGrade[props.gradeName] || {}
            const extraMealItems = (gradeItems[typeMeal] || []).map((key) => {
                return (
                    { value: key.mealId, label: key.mealName }
                )
            });
            let selectedExtraList = (extraMealItems || []).filter(item => {
                let _optionExtraSelected = props.optionExtraSelected === '' ? undefined : props.optionExtraSelected;
                _optionExtraSelected = (_optionExtraSelected ? (_optionExtraSelected.split(',')).map(id => {
                    return (id.split(':') || [])[0] || ''
                }) : []);
                return _optionExtraSelected.includes(item.value.toString());
            })
            return (
                <Select
                    isMulti
                    closeMenuOnSelect={false}
                    value={selectedExtraList}
                    onChange={(e) => this.extraItemChange(e, props)}
                    name={props.studentRecId}
                    options={extraMealItems}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />)
        }
    }
    hasMilkCard = (props) => {
        if (props.hasMilkCard) {
            return (<input type="checkbox" value={props.optMilk} checked={props.optMilk === 1} onChange={(e) => this.hasMilkCardChange(e, props)} />)
        } else {
            return '';
        }
    }
    trimText = (text = '') => {
        return text.length > 10 ? text.substring(0, 10) + '...' : text;
    }
    getColumns(data) {
        let columns = [];
        let header = ['Student Name', 'Grade', 'Item Name', 'Transaction Amount', 'Account Balance'];
        if (data.length === 0) {
            header.map(key =>
                columns.push({ Header: key }));
        } else {
            columns.push({
                accessor: 'firstName',
                Header: 'STUDENT FIRST NAME',
                Cell: props => props.original.firstName,
                style: { textAlign: 'left' }
            });
            columns.push({
                accessor: 'lastName',
                Header: 'STUDENT LAST NAME',
                Cell: props => props.original.lastName,
                style: { textAlign: 'left' }
            });
            columns.push({
                accessor: 'gradeName',
                Header: 'GRADE',
                style: { textAlign: 'center', textTransform: 'capitalize' },
                Cell: props => {
                    const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
                    return <span>{((gradeGroup[props.original.gradeName] || [])[0] || {}).label || ''}</span>
                }
            });
            columns.push({
                accessor: 'pin',
                Header: 'STUDENT PIN',
                Cell: props => <span>{props.original.pin}</span>,
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'studentId',
                Header: 'STUDENT ID',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'menuByType',
                Header: 'ITEM NAME',
                style: { textAlign: 'center' },
                Cell: props => this.getItemNames(props.original)
            });
            if ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER)
                // && isRegularLunchOrderType   
            ) {
                if (this.state.orderStatus == 'NotOrdered') {
                    columns.push({
                        accessor: 'menuByType',
                        Header: 'EXTRA ITEMS',
                        style: { textAlign: 'center', overflow: 'visible' },
                        width: 180,
                        Cell: props => this.getExtraItem(props.original)
                    })
                } else {
                    columns.push({
                        accessor: 'menuByType',
                        Header: 'EXTRA ITEMS',
                        style: { textAlign: 'center' },
                        Cell: props => this.getExtraItem(props.original)
                    })
                };
            }
            if (this.state.orderStatus == 'NotOrdered') {
                columns.push({
                    accessor: 'optionExtraSelected',
                    Header: 'Qty',
                    style: { textAlign: 'left' },
                    Cell: props => {
                        const { lunchByTypeAndGrade } = this.state;
                        const typeMeal = ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER) ? 'EXTRA' : this.state.mealType).toUpperCase();
                        const gradeItems = lunchByTypeAndGrade[props.original.gradeName] || {};
                        const extraMealItems = (gradeItems[typeMeal] || []).map((key) => {
                            return (
                                { value: key.mealId, label: key.mealName }
                            )
                        });

                        let _optionExtraSelected = props.original.optionExtraSelected === '' ? undefined : props.original.optionExtraSelected;
                        _optionExtraSelected = (_optionExtraSelected ? (_optionExtraSelected.split(',')).map(id => {
                            return { id: (id.split(':') || [])[0] || '', qty: (id.split(':') || [])[1] || '1' }
                        }) : []);
                        let selectedExtraList = [];
                        (extraMealItems || []).map(item => {
                            const idx = _optionExtraSelected.findIndex(a => a.id == item.value.toString());
                            if (idx > -1) {
                                selectedExtraList.push({ ...item, qty: _optionExtraSelected[idx].qty || 1 });
                            }
                        });

                        return <ul>{selectedExtraList.map(itm => {
                            return <li><label >{this.trimText(itm.label)} </label>
                                <input className='form-control' min={1} step={1} type="number" value={itm.qty} onKeyDown={(e) => {

                                    if (e.keyCode === 189) {
                                        e.preventDefault();
                                    }
                                }}
                                    onChange={(e) => {
                                        let noVal = e.target.valueAsNumber;
                                        if (noVal <= 0 || isNaN(noVal)) {
                                            noVal = 1;
                                        }
                                        const { optionExtraSelected, gradeName } = props.original;
                                        let transAmount = 0;
                                        const typeMeal = ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER) ? 'EXTRA' : this.state.mealType).toUpperCase();
                                        const { lunchByTypeAndGrade, _gradeName, filterData } = this.state;
                                        const _optionExtraSelected = [];
                                        (optionExtraSelected || '').split(',').map(a => {
                                            const itmArray = a.split(':');
                                            if (itm.value == itmArray[0]) {
                                                _optionExtraSelected.push({ itemId: itmArray[0], qty: noVal });
                                            } else {
                                                _optionExtraSelected.push({ itemId: itmArray[0], qty: itmArray[1] || '1' });
                                            }
                                        });
                                        const recs = ((lunchByTypeAndGrade[gradeName] || {})[typeMeal] || []).filter(item => {
                                            const idx = _optionExtraSelected.findIndex(sid => {
                                                return parseInt(item.mealId) === parseInt(sid.itemId)
                                            })
                                            if (idx !== -1) {
                                                return true;
                                            } else {
                                                return false
                                            }
                                        });
                                        recs.map(itm => {
                                            const selectedItm = _optionExtraSelected.find(item => {
                                                return itm.mealId == item.itemId;
                                            })
                                            transAmount = transAmount + (itm.mealPrice * (selectedItm ? parseInt(selectedItm.qty) : 1))
                                        })

                                        let _data = filterData.map((item_val, index_val) => {
                                            if (props.original.studentRecId === item_val.studentRecId) {
                                                return {
                                                    ...item_val,
                                                    trAmount: (transAmount + item_val.mealtrAmt),
                                                    extraTrAmt: transAmount,
                                                    optionExtraSelected: _optionExtraSelected.map(a => {
                                                        return a.itemId + ":" + a.qty
                                                    }).join(',')
                                                };
                                            } else {
                                                return item_val;
                                            }
                                        })
                                        let obj_data = _gradeName == 0 ? _data : _data.filter((itm, idx) => itm.gradeName === _gradeName)
                                        this.setState({ data: obj_data, filterData: _data }, () => {
                                            this.filterSchool();
                                        })

                                    }} /></li>
                        })}</ul>
                    }
                });
            }
            /* columns.push({
                accessor: 'hasMilkCard',
                Header: 'MILK?',
                style: { textAlign: 'center' },
                Cell: props => this.hasMilkCard(props.original)
            }); */
            columns.push({
                accessor: 'trAmount',
                Header: 'TRANSACTION AMOUNT',
                style: { textAlign: 'center' },
                Cell: props => getSalesTaxStatus() ? convertTwoDecimalPoint(getTotalAmountIncludeSalesTax(numberParce(props.original.trAmount), getSalesTaxRate())) : convertTwoDecimalPoint(props.original.trAmount)
            });
            columns.push({
                accessor: 'accBalance',
                Header: 'ACCOUNT BALANCE',
                style: { textAlign: 'center' },
                Cell: props => convertTwoDecimalPoint(props.original.accBalance)
            });
        }
        return columns;
    }
    getDataByGrade(gradeName) {
        const { filterData } = this.state;
        if (gradeName == 0) {
            this.setState({ data: filterData, _gradeName: 0 });
        } else {
            this.setState({ data: filterData.filter((item, index) => item.gradeName === gradeName), _gradeName: gradeName });
        }
    }
    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        let selectedRows = [...this.state.selectedRows]
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            selectedRows = [
                ...selectedRows.slice(0, keyIndex),
                ...selectedRows.slice(keyIndex + 1)
            ]
        } else {
            // it does not exist so add it
            selection.push(key);
            selectedRows.push(row);
        }
        // update the state
        this.setState({ selection, selectedRows });
        this.setState({ selectAll: false });
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectedRows = []
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original._id);
                selectedRows.push(item._original)
            });
        }
        this.setState({ selectAll, selection, selectedRows });
    };
    isSelected = key => {
        const res = (this.state.selection || []).find((item) => {
            const _item = ((item || '') + '').replace('select-', '');
            return _item == key;
        });
        if (res) {
            return true;
        } else {
            return false;
        }
    };
    filterSchool = () => {
        let s = document.getElementById('search').value;
        const { _gradeName } = this.state;
        let filteredData = [];
        let searchedSchool = [];
        if (s.length > 0) {
            filteredData = this.state.data;
            filteredData.forEach(obj => {
                if (obj.firstName != null && (obj.firstName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
                else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            if (_gradeName == 0) {
                this.setState({ data: searchedSchool });
            } else {
                this.setState({ data: searchedSchool.filter((item, index) => item.gradeName == _gradeName) });
            }
        }
        else {
            if (_gradeName == 0) {
                this.setState({ data: searchedSchool.length == 0 ? this.state.filterData : searchedSchool, columns: this.getColumns(searchedSchool.length == 0 ? this.state.filterData : searchedSchool) })
            } else {
                this.setState({ data: searchedSchool.length == 0 ? this.state.filterData.filter((item, index) => item.gradeName == _gradeName) : searchedSchool.filter((item, index) => item.gradeName == _gradeName), columns: this.getColumns(searchedSchool.length == 0 ? this.state.filterData.filter((item, index) => item.gradeName == _gradeName) : searchedSchool.filter((item, index) => item.gradeName == _gradeName)) })
            }

        }
        this.forceUpdate();
    };
    getSystemDateTime = () => {
        /* const selectedDateTime=moment(this.state.startDate).set( {
            hour:   moment().get('hour'),
            minute: moment().get('minute'),
            second: moment().get('second')
        })
        let _datetime=moment.utc(selectedDateTime).format('YYYY-MM-DDTH:mm:ss');
        return _datetime+'Z'; */
        return moment(this.state.startDate).format('YYYY-MM-DD');
    }
    //------PrepaidAmount-----//
    getprepaidamt = (filterStud) => {
        let accBal = (filterStud || {}).accBalance
        let itmPrice = (filterStud || {}).mealtrAmt
        const typeMeal = ((this.state.mealType === MealTypes.LUNCH ||
            this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER) ? 'MEAL' : this.state.mealType).toUpperCase();
        const typeMeal1 = ((this.state.mealType === MealTypes.LUNCH ||
            this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER) ? 'ENTREE' : this.state.mealType).toUpperCase();

        let typeM = ((filterStud['menuByType'] || {})[typeMeal] || (filterStud['menuByType'] || {})[typeMeal1] || [])
        let itemAmount = 0;
        typeM.forEach(itm => {
            if (filterStud.isReducePriceEligible) {
                itemAmount = itemAmount + (itm.reducedPrice * (itm.qty || 1));
            } else if (filterStud.isFreeMealEligible || this.state.freeMealForAll === true) {
                itemAmount = 0;
            } else {
                itemAmount = itemAmount + (itm.mealPrice * (itm.qty || 1));
            }
        })
        if (this.state.orderStatus == 'NotOrdered') {
            if (accBal >= itmPrice) {
                return itmPrice;
            } else if (accBal <= 0) {
                return 0;
            }
            else {
                return accBal;
            }
        }
        else {
            if (this.state.response) {
                return itemAmount;
            } else {
                if (accBal >= itemAmount) {
                    return itemAmount;
                } else if (accBal <= 0) {
                    return 0;
                }
                else {
                    return accBal;
                }
            }
        }

    }
    getExtraPrePaidAmt = (filterStud, RegularPrePaid) => {
        let accBal = (filterStud || {}).accBalance - RegularPrePaid
        let extItmAmt = (filterStud || {}).extraTrAmt
        const typeMeal = ((this.state.mealType === MealTypes.LUNCH ||
            this.state.mealType === MealTypes.SNACK ||
            this.state.mealType === MealTypes.BREAKFAST ||
            this.state.mealType === MealTypes.DINNER) ? 'EXTRA' : this.state.mealType).toUpperCase();
        let extraItemAmount = 0;
        ((filterStud['menuByType'] || {})[typeMeal] || []).forEach(itm => {
            extraItemAmount += (itm.mealPrice * (itm.qty || 1));

        })
        if (this.state.orderStatus == 'NotOrdered') {
            if (accBal >= extItmAmt) {
                return extItmAmt
            } else if (accBal <= 0) {
                return 0;
            }
            else {
                return accBal;
            }
        }
        else {
            if (this.state.response) {
                return extraItemAmount
            }
            else {
                if (accBal >= extraItemAmount) {
                    return extraItemAmount;
                } else if (accBal <= 0) {
                    return 0;
                }
                else {
                    return accBal;
                }
            }
        }

    }
    //------PrepaidAmount End-----//
    //-----studentWiseTransactions with mealType-----//
    getStudentWiseTransactions = (filterStud) => {
        var transactionArray = []
        if (this.state.orderStatus == 'NotOrdered') {
            var prepaidAmount = this.getprepaidamt(filterStud)
            if (filterStud.itemSelected) {
                transactionArray.push(
                    {
                        eligStatus: (((filterStud || {}).isFreeMealEligible) || (this.state.freeMealForAll === true) || (((filterStud || {}).isBeforeCare)) && (this.state.mealType === MealTypes.BREAKFAST)) ? 0 : ((filterStud || {}).isReducePriceEligible ? 1 : 2),
                        emrgLunchServe: "false",
                        studentRecId: (filterStud || {}).studentRecId,
                        transactionAmount: (filterStud || {}).mealtrAmt,
                        salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount((filterStud || {}).mealtrAmt, getSalesTaxRate()) : 0,
                        prepaidAmt: prepaidAmount,
                        mealType: "Regular",
                        items: [{ id: filterStud.itemSelected, qty: 1 }]
                    }
                )
            }
            if (filterStud.optionExtraSelected) {
                transactionArray.push(
                    {
                        eligStatus: (((filterStud || {}).isFreeMealEligible) || (this.state.freeMealForAll === true) || (((filterStud || {}).isBeforeCare)) && (this.state.mealType === MealTypes.BREAKFAST)) ? 0 : ((filterStud || {}).isReducePriceEligible ? 1 : 2),
                        emrgLunchServe: "false",
                        studentRecId: (filterStud || {}).studentRecId,
                        prepaidAmt: this.getExtraPrePaidAmt(filterStud, prepaidAmount),
                        transactionAmount: (filterStud || {}).extraTrAmt,
                        salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount((filterStud || {}).extraTrAmt, getSalesTaxRate()) : 0,
                        mealType: "ALaCarte",
                        items: filterStud.optionExtraSelected.split(',').map(item => {
                            const itmArray = item.split(':');
                            return { id: itmArray[0], qty: itmArray[1] || '1' }
                        })
                    }
                )
            }
        }
        else if (this.state.orderStatus == 'Ordered') {
            const typeMeal = ((this.state.mealType === MealTypes.LUNCH) ? 'MEAL' : (this.state.mealType === MealTypes.SNACK ||
                this.state.mealType === MealTypes.BREAKFAST ||
                this.state.mealType === MealTypes.DINNER)
                ? this.state.mealType : ' ').toUpperCase();
            const typeMeal1 = ((this.state.mealType === MealTypes.LUNCH ||
                this.state.mealType === MealTypes.SNACK ||
                this.state.mealType === MealTypes.BREAKFAST ||
                this.state.mealType === MealTypes.DINNER) ? 'ENTREE' : this.state.mealType).toUpperCase();
            let typeM = ((filterStud['menuByType'] || {})[typeMeal] || (filterStud['menuByType'] || {})[typeMeal1] || [])
            var prepaidAmount = this.getprepaidamt(filterStud)
            if (typeM.length > 0) {
                const eligStatus = (((filterStud || {}).isFreeMealEligible) || (this.state.freeMealForAll === true) || (((filterStud || {}).isBeforeCare)) && (this.state.mealType === MealTypes.BREAKFAST)) ? 0 : ((filterStud || {}).isReducePriceEligible ? 1 : 2)
                let mPrice = 0;
                if (!this.state.isInstantPayment) {
                    typeM.map(item => {
                        mPrice = mPrice + parseFloat(convertTwoDecimalPoint(eligStatus === 0 ? 0 : (eligStatus === 1) ? item.reducedPrice : item.mealPrice)) * (item.qty || 1)
                    });
                }
                transactionArray.push(
                    {
                        eligStatus: eligStatus,
                        emrgLunchServe: "false",
                        studentRecId: (filterStud || {}).studentRecId,
                        transactionAmount: mPrice,
                        salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount(mPrice, getSalesTaxRate()) : 0,
                        prepaidAmt: prepaidAmount,
                        mealType: "Regular",
                        items: typeM.map(itm => {
                            return { id: itm.mealId, qty: itm.qty || 1 }
                        })
                    }
                )
            }
            const typeExtra = ((this.state.mealType === MealTypes.LUNCH || this.state.mealType === MealTypes.BREAKFAST || this.state.mealType === MealTypes.SNACK || this.state.mealType === MealTypes.DINNER) ? 'EXTRA' : this.state.mealType).toUpperCase();
            let typeE = ((filterStud['menuByType'] || {})[typeExtra] || [])
            if (typeE.length > 0) {
                let mPrice = 0;
                if (!this.state.isInstantPayment) {
                    typeE.map(item => {
                        mPrice = mPrice + parseFloat(convertTwoDecimalPoint(item.mealPrice)) * (item.qty || 1)
                    });
                }

                transactionArray.push(
                    {
                        eligStatus: (((filterStud || {}).isFreeMealEligible) || (this.state.freeMealForAll === true) || (((filterStud || {}).isBeforeCare)) && (this.state.mealType === MealTypes.BREAKFAST)) ? 0 : ((filterStud || {}).isReducePriceEligible ? 1 : 2),
                        emrgLunchServe: "false",
                        studentRecId: (filterStud || {}).studentRecId,
                        prepaidAmt: this.getExtraPrePaidAmt(filterStud, prepaidAmount),
                        transactionAmount: mPrice,
                        salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount(mPrice, getSalesTaxRate()) : 0,
                        mealType: "ALaCarte",
                        items: typeE.map(itm => {
                            return { id: itm.mealId, qty: itm.qty || 1 }
                        })
                    }
                )
            }
        }
        return transactionArray
    }
    //-----studentWiseTransactions with mealType End-----//
    saveTransaction = (e, callback) => {
        e.preventDefault();
        let selectedRows = this.state.selectedRows;
        let selectedData = this.state.data;
        let purchseItemAudit = [];
        if (selectedRows.length > 0) {
            let allItemSelected = selectedRows.every(item => {
                let idx = selectedData.findIndex(r => {
                    return item.studentRecId == r.studentRecId;
                });
                if (idx !== -1) {
                    return ((selectedData[idx].itemSelected !== undefined) || selectedData[idx].optionExtraSelected !== undefined || ((selectedData[idx].optMilk == 1) === true))
                } else {
                    return false;
                }
            })
            if (!allItemSelected && this.state.orderStatus !== 'Ordered') {
                _addNotificationError('Please select meal item or milk for all selected students', this);
                return;
            }
            selectedRows.map((item, index) => {
                if (this.state.mealType === MealTypes.BREAKFAST) {
                    if (item.optMilk === 1) {
                        purchseItemAudit.push({
                            isItemTaken: "true",
                            payToAmt: "",
                            purchaseItemType: "Milk",
                            studentWiseTransactions: [

                                {
                                    eligStatus: item.isFreeMealEligible || (this.state.freeMealForAll === true) || item.isBeforeCare ? 0 : (item.isReducePriceEligible ? 1 : 2),
                                    emrgLunchServe: "false",
                                    studentRecId: item.studentRecId,
                                    transactionAmount: item.milktrAmt,
                                    salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount(item.milktrAmt, getSalesTaxRate()) : 0
                                }
                            ],
                            totalTransactionAmount: item.milktrAmt,
                            salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount(item.milktrAmt, getSalesTaxRate()) : 0,
                            transactionDescription: `Milk purchased with ${currency_symbol()} ${item.milktrAmt}`,
                            transactionType: "Purchase",
                            isPrePaid: this.state.response && item.menuByType !== null ? true : false
                        })
                    }
                }
                else {
                    if (item.optMilk === 1) {
                        purchseItemAudit.push({
                            isItemTaken: "true",
                            payToAmt: "",
                            purchaseItemType: "Milk",
                            studentWiseTransactions: [

                                {
                                    eligStatus: item.isFreeMealEligible || (this.state.freeMealForAll === true) ? 0 : (item.isReducePriceEligible ? 1 : 2),
                                    emrgLunchServe: "false",
                                    studentRecId: item.studentRecId,
                                    transactionAmount: item.milktrAmt,
                                    salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount(item.milktrAmt, getSalesTaxRate()) : 0
                                }
                            ],
                            totalTransactionAmount: item.milktrAmt,
                            salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount(item.milktrAmt, getSalesTaxRate()) : 0,
                            transactionDescription: `Milk purchased with ${currency_symbol()} ${item.milktrAmt}`,
                            transactionType: "Purchase",
                            isPrePaid: this.state.response && item.menuByType !== null ? true : false
                        })
                    }
                }
                let filterStud = this.state.filterData.find(s => {
                    return s.studentRecId == item.studentRecId
                })
                const typeMeal = this.state.mealType;
                let idx = selectedData.findIndex(r => {
                    return item.studentRecId == r.studentRecId;
                });
                if (this.state.orderStatus == 'NotOrdered') {
                    if (selectedData[idx].itemSelected !== undefined || selectedData[idx].optionExtraSelected !== undefined) {
                        if (this.state.mealType === MealTypes.BREAKFAST) {

                            purchseItemAudit.push({
                                isItemTaken: "true",
                                payToAmt: "",
                                purchaseItemType: typeMeal,
                                studentWiseTransactions: this.getStudentWiseTransactions(filterStud),
                                totalTransactionAmount: (filterStud || {}).mealtrAmt,
                                salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount((filterStud || {}).mealtrAmt, getSalesTaxRate()) : 0,
                                transactionDescription: `${typeMeal} purchased with ${currency_symbol()} ${(filterStud || {}).mealtrAmt}`,
                                transactionType: "Purchase",
                                isPrePaid: this.state.response && (filterStud || {}).menuByType !== null ? true : false
                            })


                        }
                        else {
                            const totalLunchAmt = ((filterStud || {}).mealtrAmt) + ((filterStud || {}).extraTrAmt);
                            purchseItemAudit.push({
                                isItemTaken: "true",
                                payToAmt: "",
                                purchaseItemType: typeMeal,
                                studentWiseTransactions: this.getStudentWiseTransactions(filterStud),
                                totalTransactionAmount: totalLunchAmt,
                                salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount(totalLunchAmt, getSalesTaxRate()) : 0,
                                transactionDescription: `${typeMeal} purchased with ${currency_symbol()} ${totalLunchAmt}`,
                                transactionType: "Purchase",
                                isPrePaid: this.state.response && (filterStud || {}).menuByType !== null ? true : false
                            })
                        }
                    }
                }
                else {
                    if (this.state.mealType === MealTypes.BREAKFAST) {

                        purchseItemAudit.push({
                            isItemTaken: "true",
                            payToAmt: "",
                            purchaseItemType: typeMeal,
                            studentWiseTransactions: this.getStudentWiseTransactions(filterStud),
                            totalTransactionAmount: ((filterStud || {}).mealtrAmt * ((filterStud || {}).qty || 1)),
                            salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount((filterStud || {}).mealtrAmt, getSalesTaxRate()) : 0,
                            transactionDescription: `${typeMeal} purchased with ${currency_symbol()} ${((filterStud || {}).mealtrAmt * ((filterStud || {}).qty || 1))}`,
                            transactionType: "Purchase",
                            isPrePaid: this.state.response && (filterStud || {}).menuByType !== null ? true : false
                        })

                    }
                    else {

                        purchseItemAudit.push({
                            isItemTaken: "true",
                            payToAmt: "",
                            purchaseItemType: typeMeal,
                            studentWiseTransactions: this.getStudentWiseTransactions(filterStud),
                            totalTransactionAmount: ((filterStud || {}).mealtrAmt * ((filterStud || {}).qty || 1)),
                            salesTaxAmt: getSalesTaxStatus() ? getSalesTaxAmount((filterStud || {}).mealtrAmt, getSalesTaxRate()) : 0,
                            transactionDescription: `${typeMeal} purchased with ${currency_symbol()} ${((filterStud || {}).mealtrAmt * ((filterStud || {}).qty || 1))}`,
                            transactionType: "Purchase",
                            isPrePaid: this.state.response && (filterStud || {}).menuByType !== null ? true : false
                        })
                    }
                }
            })
            let headers = {
                'Content-Type': 'application/json'
            };
            let finalReqObj = [];
            purchseItemAudit.forEach(std => {
                const _std = JSON.parse(JSON.stringify(std));
                std.studentWiseTransactions.forEach((tr, idx) => {
                    const itmGroupBy = groupBy(tr.items, 'id');
                    const _itmsList = Object.keys(itmGroupBy).map(iid => {
                        return {
                            item: { id: iid },
                            qty: ((itmGroupBy[iid] || [])[0] || {}).qty || 1
                        };
                    });
                    _std.studentWiseTransactions[idx].itemsWithQty = _itmsList;

                });
                finalReqObj.push(_std);
            })
            let schoolId = sessionStorage.getItem('SchoolId');
            postWithHeaders(`/transactions/purchaseItemsAuditV2?mealSchoolId=${schoolId}&systemDateTime=${this.getSystemDateTime()}&access_token=`, JSON.stringify(finalReqObj), headers).then((response) => {
                if (response.status === 200) {
                    this.setState({ loading: false })
                    _addNotification('Purchase transaction successful', this);
                    callback(true);
                    this.initTransaction(true);
                } else if (!response.ok) {
                    throw Error(response.statusText);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    callback(true);
                    _addNotificationError('Failed to send link ! Try again.', this);
                    console.log('Send Notification Error', error)
                }
            );
        } else {
            _addNotificationError('Please select at least one student.', this);
            callback(true);
        }
    }
    render() {
        gradeList = getSchoolGrades();
        const { toggleSelection, toggleAll, isSelected } = this;
        const { data, selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
            })
        }
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="sectionTitle">
                            <div className="row">
                                <div className="col-md-2">
                                    <h2><span>Add Transaction</span></h2>
                                </div>
                                <div className="uploadFileInfo col-md-4 createmenu-month-group">
                                    <div className="input-group col-md-8 col-sm-12 col-xs-12" style={{ margin: '15px 0 0 12px' }}>
                                        <Datetime ref='trCalendar' dateFormat={date_format()} timeFormat={false} isValidDate={disableFutureDt}
                                            closeOnSelect={true} value={moment(this.state.startDate, 'YYYY-MM-DD')}
                                            onChange={(e) => {
                                                this.setState({ startDate: moment(e).format('YYYY-MM-DD') });
                                                let schoolYear = sessionStorage.getItem('schoolYearValue');
                                                let schoolId = sessionStorage.getItem('SchoolId');
                                                this.getPurchasedMenuStudents(moment(e).format('YYYY-MM-DD'), schoolId);
                                                this.getMenuAvaialableByGrade(moment(e).format('YYYY-MM-DD'), schoolId, schoolYear, this.state.orderStatus);
                                                this.refs.trCalendar.closeCalendar();
                                            }} renderInput={this.renderInput} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pull-right" style={{ marginBottom: '5px' }}>
                            <div style={{ display: 'inline-block' }}>
                                <MenuOptions menuOptionsList={getTransactionOptions()} onOptionSelect={(type) => {
                                    this.setState({ mealType: type, selectedRows: [], selection: [], selectAll: false }, () => {
                                        let schoolId = sessionStorage.getItem('SchoolId');
                                        let schoolYear = sessionStorage.getItem('schoolYearValue');
                                        this.getPurchasedMenuStudents(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId);
                                        const orderFilter = (isShowOrderOption(this.state.mealType) ? "Ordered" : (isRegularLunchOrderType() ? "NotOrdered" : "Ordered"));
                                        this.getMenuAvaialableByGrade(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId, schoolYear, orderFilter);
                                    })
                                }} selectedOption={(this.state.mealType)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            <section className="clearfix">
                                                <div className="tab-content">
                                                    <div className="media">
                                                        <div className="panel panel-primary">
                                                            <div className="panel-body">
                                                                <div>
                                                                    <Tabs>
                                                                        <div>
                                                                            <TabList>
                                                                                <div className="pull-right">
                                                                                    <div id="selector" className="btn-group pull-right"
                                                                                        style={{ float: 'right', margin: '-7px' }}>
                                                                                        {
                                                                                            isRegularLunchOrderType() ?
                                                                                                <div>
                                                                                                    {
                                                                                                        isShowOrderOption(this.state.mealType) ?
                                                                                                            <button type="button" className={this.state.orderStatus == 'Ordered' ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"}
                                                                                                                id="Ordered"
                                                                                                                style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                                                                                                                onClick={() => {
                                                                                                                    let schoolYear = sessionStorage.getItem('schoolYearValue');
                                                                                                                    let schoolId = sessionStorage.getItem('SchoolId');
                                                                                                                    this.getMenuAvaialableByGrade(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId, schoolYear, 'Ordered');
                                                                                                                    this.setState({ selectAll: false, selection: [], selectionIds: [], orderStatus: 'Ordered', selectedRows: [] })
                                                                                                                }}>Ordered
                                                                                                            </button> : null
                                                                                                    }

                                                                                                    <button type="button" className={this.state.orderStatus == 'NotOrdered' ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"}
                                                                                                        style={{ margin: 0, marginLeft: 5, fontSize: 14 }} id="NotOrdered"
                                                                                                        onClick={() => {
                                                                                                            let schoolYear = sessionStorage.getItem('schoolYearValue');
                                                                                                            let schoolId = sessionStorage.getItem('SchoolId');
                                                                                                            this.getMenuAvaialableByGrade(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId, schoolYear, 'NotOrdered');
                                                                                                            this.setState({ selectAll: false, selection: [], selectionIds: [], orderStatus: 'NotOrdered', selectedRows: [] })
                                                                                                        }}>Not
                                                                                                        Ordered
                                                                                                    </button>
                                                                                                </div> : <div>
                                                                                                    {
                                                                                                        isShowOrderOption(this.state.mealType) ?
                                                                                                            <button type="button" className="btn btn-xs btn-inactive-color active"
                                                                                                                id="Ordered"
                                                                                                                style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                                                                                                                onClick={() => {
                                                                                                                    let schoolYear = sessionStorage.getItem('schoolYearValue');
                                                                                                                    let schoolId = sessionStorage.getItem('SchoolId');
                                                                                                                    this.getMenuAvaialableByGrade(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId, schoolYear, 'Ordered');
                                                                                                                    this.setState({ selectAll: false, selection: [], selectionIds: [], orderStatus: 'Ordered', selectedRows: [] })
                                                                                                                }}>Ordered
                                                                                                            </button> : null
                                                                                                    }
                                                                                                    <button type="button" className={this.state.orderStatus == 'NotOrdered' ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"}
                                                                                                        style={{ margin: 0, marginLeft: 5, fontSize: 14 }} id="NotOrdered"
                                                                                                        onClick={() => {
                                                                                                            let schoolYear = sessionStorage.getItem('schoolYearValue');
                                                                                                            let schoolId = sessionStorage.getItem('SchoolId');
                                                                                                            this.getMenuAvaialableByGrade(moment(this.state.startDate).format('YYYY-MM-DD'), schoolId, schoolYear, 'NotOrdered');
                                                                                                            this.setState({ selectAll: false, selection: [], selectionIds: [], orderStatus: 'NotOrdered', selectedRows: [] })
                                                                                                        }}>Not
                                                                                                        Ordered
                                                                                                    </button>
                                                                                                </div>

                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                                {gradeList.map((item) => {
                                                                                    return <Tab onClick={() => {
                                                                                        this.state.tabIndex = item.value;;
                                                                                        this.setState({ selectAll: false })
                                                                                        this.getDataByGrade(item.value);

                                                                                    }}> {item.label}</Tab>
                                                                                }, this)}
                                                                            </TabList>
                                                                            <TabPanel>
                                                                                <div className="row">
                                                                                    <div className="col-xs-3 pull-left">
                                                                                        <input type="text" id="search"
                                                                                            className="form-control"
                                                                                            style={{
                                                                                                float: 'left',
                                                                                                margin: '5px 0'
                                                                                            }}
                                                                                            name="search"
                                                                                            placeholder="Search.."
                                                                                            onKeyUp={this.filterSchool}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-md-9">
                                                                                        <CustomSubmit id="addSchool" type="button" className="btn btn-success button-sm pull-right"
                                                                                            style={{
                                                                                                margin: '0'
                                                                                            }}
                                                                                            handleSubmit={(e, callback) => this.saveTransaction(e, callback)}
                                                                                        >
                                                                                            <i className="glyphicon glyphicon-ok"></i> Save Transaction</CustomSubmit>
                                                                                    </div>
                                                                                </div>
                                                                                {data ? (
                                                                                    <CheckboxTable
                                                                                        ref={r => (this.checkboxTable = r)}
                                                                                        data={this.state.data.sort((a, b) => {
                                                                                            const aName = `${a.lastName} ${a.firstName}`;
                                                                                            const bName = `${b.lastName} ${b.firstName}`;
                                                                                            if (aName.toUpperCase() < bName.toUpperCase()) return -1;
                                                                                            if (aName.toUpperCase() > bName.toUpperCase()) return 1;
                                                                                            return 0;
                                                                                        })}
                                                                                        columns={this.state.columns}
                                                                                        defaultPageSize={10}
                                                                                        className="-striped -highlight"
                                                                                        {...checkboxProps}
                                                                                    />) : null}
                                                                            </TabPanel>

                                                                            {gradeList.map(function (key) {
                                                                                return (
                                                                                    <TabPanel>
                                                                                        <div className="row">
                                                                                            <div className="col-xs-3 pull-left">
                                                                                                <input type="text" id="search"
                                                                                                    className="form-control"
                                                                                                    style={{
                                                                                                        float: 'left',
                                                                                                        margin: '5px 0'
                                                                                                    }}
                                                                                                    name="search"
                                                                                                    placeholder="Search.."
                                                                                                    onKeyUp={this.filterSchool}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="col-md-9">
                                                                                                <CustomSubmit id="addSchool" type="button" className="btn btn-success button-sm pull-right"
                                                                                                    style={{
                                                                                                        margin: '0'
                                                                                                    }}
                                                                                                    handleSubmit={(e, callback) => this.saveTransaction(e, callback)}
                                                                                                >
                                                                                                    <i className="glyphicon glyphicon-ok"></i> Save Transaction</CustomSubmit>

                                                                                            </div>
                                                                                        </div>
                                                                                        {data ? (
                                                                                            <CheckboxTable
                                                                                                ref={r => (this.checkboxTable = r)}
                                                                                                data={this.state.data.sort((a, b) => {
                                                                                                    const aName = `${a.lastName} ${a.firstName}`;
                                                                                                    const bName = `${b.lastName} ${b.firstName}`;
                                                                                                    if (aName.toUpperCase() < bName.toUpperCase()) return -1;
                                                                                                    if (aName.toUpperCase() > bName.toUpperCase()) return 1;
                                                                                                    return 0;
                                                                                                })}
                                                                                                columns={this.state.columns}
                                                                                                defaultPageSize={10}
                                                                                                className="-striped -highlight"
                                                                                                {...checkboxProps}
                                                                                            />) : null}
                                                                                    </TabPanel>)
                                                                            }, this)}
                                                                        </div>
                                                                    </Tabs>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

}
addTransaction.contextTypes = {
    router: PropTypes.object.isRequired
}
export default addTransaction;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Transactions/addTransaction.js